// extracted by mini-css-extract-plugin
export default {"block":"DropZone_block__wc-MI","addImg":"DropZone_addImg__aLD-o","dFlex":"DropZone_dFlex__NkaYz","upload":"DropZone_upload__xg-rB","loading":"DropZone_loading__tGa5x"};